import React, { Fragment } from 'react'
import { Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import useRegister from '../../Hooks/Auth/useRegister'
import AppButton from '../Main/Button'
import { AppInput, AppPhoneInput, PasswordInput } from '../Main/Inputs'

const SignUpPage = () => {

    const [
        firstName,
        lastName,
        email,
        phoneNumber,
        password,
        confirmPassword,
        isLoading,
        handleFirstName,
        handleLastName,
        handleEmail,
        handlePhoneNumber,
        handlePassword,
        handleConfirmPassword,
        handleSubmit
    ] = useRegister();

    return (
        <Fragment>
            <div className="auth-background">
                <div className="overlay h-100" >
                    <div className="container">
                        <div className="row ">
                            <div className="col-lg-5 my-5">
                                <div className=" card bg-white border-0 p-5">
                                    <h5 className='heading'>
                                        Sign Up
                                    </h5>

                                    <p>
                                        Don’t have an account? <Link className='text-danger' to={"/login"}>Sign in</Link>
                                    </p>

                                    <Form className='row'>
                                        <div className="col-6 ps-0">


                                            <AppInput
                                                type="text"
                                                placeholder="First Name"
                                                handleChange={handleFirstName}
                                                value={firstName}
                                            />
                                        </div>
                                        <div className="col-6 pe-0">

                                            <AppInput
                                                type="text"
                                                placeholder="Last Name"
                                                handleChange={handleLastName}
                                                value={lastName}
                                            />
                                        </div>
                                        <div className="col-12 px-0">

                                            <AppInput
                                                type="email"
                                                placeholder="Email"
                                                icon={"email"}
                                                handleChange={handleEmail}
                                                value={email}
                                            />
                                        </div>

                                        <div className="col-12 px-0">

                                            {/* <AppInput
                                                type="number"
                                                placeholder="Phone Number"
                                                icon={"phone"}
                                                handleChange={handlePhoneNumber}
                                                value={phoneNumber}
                                            /> */}

                                            <AppPhoneInput
                                                handleChange={handlePhoneNumber}
                                                value={phoneNumber}
                                            />
                                        </div>

                                        <div className="col-12 px-0">
                                            <PasswordInput
                                                placeholder="Password"
                                                handleChange={handlePassword}
                                                value={password}
                                            />
                                        </div>

                                        <div className="col-12 px-0">
                                            <PasswordInput
                                                placeholder="Confirm Password"
                                                handleChange={handleConfirmPassword}
                                                value={confirmPassword}
                                            />
                                        </div>

                                        <div className='p-0'>

                                            <AppButton
                                                type='submit'
                                                isLoading={isLoading}
                                                title={"Sign Up"}
                                                className={"w-100 py-3"}
                                                handleClick={handleSubmit}
                                            />
                                        </div>
                                    </Form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default SignUpPage